import { Modal } from "../components/modal.js";
import { ExpandedBtn } from "../components/expanded-btn.js";

// Global functions
// get left/top position of a element
const setActive = (el, className = "is-active") => {
	[...el.parentElement.children].forEach((sib) => sib.classList.remove(className));
	el.classList.add(className);
};

const offset = function (el) {
	const rect = el.getBoundingClientRect();
	return {
		left: rect.left + window.scrollX,
		top: rect.top + window.scrollY,
	};
};

document.addEventListener("DOMContentLoaded", () => {
	Modal.init();

	/**
	 * Check if we can change the current step
	 *
	 * @param stepToGo
	 */
	function changeTheStep(stepToGo) {
		// change the current step
		dataStep = stepToGo;
		const formSteps = document.querySelectorAll(".form-estimation__step");
		formSteps.forEach((sec) => {
			if (parseInt(sec.dataset.step) === dataStep) {
				setActive(sec, "is-visible");
			}
		});

		// Update pagination
		const paginations = document.querySelectorAll("[data-pagination]");
		paginations.forEach((page) => {
			page.classList.remove("is-active");
			if (parseInt(page.dataset.pagination) === dataStep) {
				page.classList.add("is-active");
			}
		});
	}

	const enableNextButton = (parent) => {
		const inputs = parent.querySelectorAll("input[required]");
		const btn = parent.querySelector(`[data-step-go="${dataStep + 1}"], button[type="submit"]`);
		let isValid = true;

		for (var i = 0; i < inputs.length; i++) {
			let changedInput = inputs[i];
			if (changedInput.value.trim() === "" || changedInput.value === null) {
				isValid = false;
				break;
			}
		}

		btn.disabled = !isValid;
	};

	let dataStep = 1;
	let $formStepButtons;
	$formStepButtons = document.querySelectorAll("[data-step-go]");
	const $form = document.querySelector(".js-form-estimation");
	const $formSteps = $form.querySelectorAll(".form-estimation__step");

	// Form steps
	if ($form && $formStepButtons) {
		// Change Step on click
		changeTheStep(1);
		$formStepButtons.forEach((el) => {
			el.addEventListener("click", (e) => {
				e.preventDefault();

				changeTheStep(parseInt(el.dataset.stepGo));
			});
		});

		$formSteps.forEach((step) => {
			const formFields = step.querySelectorAll("input");
			formFields.forEach((input) => {
				input.addEventListener("keyup", (e) => {
					enableNextButton(step);
				});
			});
		});

		let $jq_form = $("#js-form-estimation");

		$jq_form.on("submit", (e) => {
			e.preventDefault();
			const loader = document.querySelector(".loader");
			loader.style.display = "block";
			e.currentTarget.querySelector('button[type="submit"]').disabled = true;

			// set default data and add form data
			let data = {};
			$.each($jq_form.serializeArray(), (i, el) => {
				data[el.name] = el.value;
			});

			data.post_id = maillard_theme_vars.current_post_id;

			$.post({
				url: ajaxurl,
				data: {
					action: "maillard_theme",
					function: "maillard_send_estimation",
					data: data,
				},
				success: (response) => {
					if (!response) {
						return false;
					}

					if (response.success === true) {
						let success_message = response.data.message;
						const $ctnForm = document.getElementById("column-form-estimation");

						$(".dynamic-recipient input[type='email']").val(response.data.recipient_email);
						loader.style.display = "none";
						e.currentTarget.disabled = false;
						
						$ctnForm.scrollIntoView();
						$ctnForm.innerHTML = success_message;

						ExpandedBtn.init();
						Modal.init();
					} else {
						const $returnMessage = document.querySelector(".form-estimation__msg");
						$returnMessage.classList.add("is-visible");

						// transform string to array if not already one
						if ($.isArray(response.data[0].message)) {
							$.each(JSON.parse(response.data[0].message), (i, message) => {
								$returnMessage.innerHTML = message;
							});
						} else {
							$returnMessage.innerHTML = response.data[0].message;
						}
					}
				},
			});
		});
	}

	// Show NewsBlock on the bottom when scrolling
	let scrollPosition = window.scrollY;
	let newsBlock = document.querySelector(".bloc-news");
	let newsSticky = document.querySelector(".sticky-news");
	let minimizeNewsBlock = document.querySelector(".bloc-news__close");

	if (newsBlock) {
		window.addEventListener("scroll", () => {
			scrollPosition = window.scrollY;

			if (scrollPosition >= offset(newsBlock).top) {
				newsSticky.classList.add("is-visible");
			} else {
				newsSticky.classList.remove("is-visible");
			}
		});

		minimizeNewsBlock.addEventListener("click", (e) => {
			e.preventDefault();
			newsSticky.classList.add("is-visible");
			newsBlock.classList.add("is-hidden");
		});
	}

	//  Form subtype
	let formSubtypeTrigger = document.querySelectorAll("input[name='type']");
	let formSubtype = document.querySelectorAll("[data-sub-type]");

	if (formSubtypeTrigger) {
		formSubtypeTrigger.forEach((el) => {
			el.addEventListener("click", (e) => {
				let type = e.currentTarget.dataset.type;

				// disable surface_landing for apartment
				if (type === "apartment") {
					$('[name="surface_landing"]').attr("disabled", "disabled").parent().addClass("d-none");
				} else {
					$('[name="surface_landing"]').removeAttr("disabled").parent().removeClass("d-none");
				}

				formSubtype.forEach((el) => {
					el.classList.remove("is-visible");
					if (el.getAttribute("data-sub-type") == type) {
						el.classList.add("is-visible");
					}
				});
			});
		});
	}
});

// init google maps autocomplete
// let $street = document.getElementById('street');
// let gm_street = new google.maps.places.Autocomplete($street, {
// 	componentRestrictions: {country: 'ch'}, types: ['address']
// });

// init map
// let map = new google.maps.Map(document.getElementById("estimation-google-map"), {
// 	zoom: 11,
// 	mapTypeControl: false,
// 	streetViewControl: false,
// 	fullscreenControl: false,
// 	center: {lat: 46.54, lng: 6.64},
// });

// init marker
// let marker = new google.maps.Marker();

// Map in the 2nd step
// new googleMaps;
// class googleMaps {
// 	constructor() {
// 		// add marker to the map
// 		marker.setMap(map);
// 		// marker.setIcon(this.siteUrl + "/wp-content/plugins/procab-property-estimation/assets/images/marker.png");

// 		setTimeout(() => $street.setAttribute('autocomplete', 'nope'), 250);
// 		// this.pacSelectFirst($street);

// 		// add watcher on each inputs
// 		gm_street.set('place',null);
// 		gm_street.addListener("place_changed", this.placeChangeHandler);
// 		document.getElementById("npa").addEventListener('focusout', this.placeChangeHandler);
// 		document.getElementById("city").addEventListener('focusout', this.placeChangeHandler);
// 		document.getElementById("house_number").addEventListener('focusout', this.placeChangeHandler);
// 	}

// 	placeChangeHandler() {
// 		let places = gm_street.getPlace();

// 		if(typeof(places) === 'undefined' || typeof(places) === 'null') {
// 			return;
// 		}

// 		$.each(places.address_components, (i, address_component) => {
// 			if (address_component.types[0] === 'route') {
// 				document.getElementById('street').value = address_component.long_name;
// 			} else if (address_component.types[0] === 'administrative_area_level_2') {
// 				document.getElementById('city').value = address_component.long_name;
// 			} else if (address_component.types[0] === 'postal_code') {
// 				document.getElementById('npa').value = address_component.long_name;
// 			} else if (address_component.types[0] === 'street_number') {
// 				document.getElementById('house_number').value = address_component.long_name;
// 			}
// 		});

// 		let address = document.getElementById("street").value+' '+document.getElementById('house_number').value+', '+document.getElementById("npa").value +document.getElementById('city').value;

// 		/* ---------------------- Fin construction de l'adresse --------------------- */
// 		new google.maps.Geocoder().geocode({
// 			'address': address
// 		}, (results, status) => {
// 			if (status === 'OK') {
// 				// fill the hidden input to remove the disable on next button
// 				$('#property_localisation').attr('value', address);
// 				$('#property_localisation_alert').addClass('opacity-0');

// 				map.setZoom(17);
// 				map.setCenter(results[0].geometry.location);
// 				marker.setPosition(results[0].geometry.location);
// 				marker.setVisible(true);
// 			} else {
// 				console.log('Geocode was not successful for the following reason: ' + status);
// 			}
// 		});
// 	}
// }
